import FieldConfig from "../../../proto/field-config"
import FieldItemModelTimeReportedCalculated_TableCell from "./render/table/table-cell"
import FieldProto from "../../../proto/field-proto"
import {SortDirection} from "../../../../data-structures/sort"
import ItemModelV2 from "../../../../model2/item2/item-model"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"
import {ItemModelV2_CalculatedValues} from "../../../../model2/item2/calculated/@type"
import FieldEstimate_AggregateCell from "../../../generic/estimate/render/aggregate/aggregate-cell"
import FieldEstimate_BoardAggregate from "../../../generic/estimate/render/aggregate/board-aggregate";

export default class FieldItemModelTimeReportedCalculated extends FieldProto {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel                              = "Time reported"
        this.label                                  = "Time reported"
        this.icon                                   = 'i5-my-time'

        this.hasCalculatedValues                    = true

        this.renderComponents.tableCell             = FieldItemModelTimeReportedCalculated_TableCell
        this.renderComponents.tableCellCalculated   = FieldItemModelTimeReportedCalculated_TableCell
        this.renderComponents.aggregateCell         = FieldEstimate_AggregateCell
        this.renderComponents.boardAggregate        = FieldEstimate_BoardAggregate
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [
                (listItem: ItemModelV2) => {
                    const dataByAggregateFunc = listItem.calculated.dataByAggregateFunction[this.fieldId]
                    const calculatedValues: ItemModelV2_CalculatedValues = dataByAggregateFunc?.[_.keys(dataByAggregateFunc)[0] as keyof {}] // take first property from dataByAggregateFunc
                    return calculatedValues?.total.value || 0
                }
            ],
            directions  : [sort]
        }
    }

    /** AGGREGATE **/
    getAggregateOptions() {return [
        AggregateFunctionType.SUM,
        AggregateFunctionType.MIN,
        AggregateFunctionType.MAX,
        AggregateFunctionType.MEDIAN,
        AggregateFunctionType.AVERAGE
    ]}

    getDefaultAggregateFunction() {
        return AggregateFunctionType.SUM
    }
}